import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

type SortDirection = 'ASC' | 'DESC';
interface SortState {
  category: string;
  direction: SortDirection;
}
@Component({
  selector: 'app-codex-indicator-view',
  templateUrl: './codex-indicator-view.component.html',
  styleUrls: ['./codex-indicator-view.component.scss']
})
export class CodexIndicatorViewComponent implements OnInit {
  @ViewChild('carousel') carousel: any;

  @Input() currentReport!: any;
  @Input() codexesByCategory!: any;

  @Output() indicatorChanges = new EventEmitter<any>();
  
  currentPage: number = 0;
  activeSort: SortState | null = null;

  activeMenuCategory: any;

  constructor() { }

  ngOnInit(): void {
  }

  isCenter(index: number): boolean {
    return index % this.currentReport.details.length === (this.currentPage + 1) % this.currentReport.details.length;
  }

  changeIndicator(event: any) {
    this.currentPage = event.page;
    this.indicatorChanges.emit({categoryUuid: this.currentReport.details[event.page].category.uuid, order: this.activeSort ? this.activeSort?.direction : null});
  }

  nextCarouselPage() {
    this.carousel.navForward();
  }

  prevCarouselPage() {
    this.carousel.navBackward();
  }

  openSortMenu(category: string) {
    if (this.activeMenuCategory === category) {
      this.activeMenuCategory = null;
    } else {
      this.activeMenuCategory = category;
    }
  }

  toggleSort(category: string, direction: SortDirection) {
    if (this.activeSort && this.activeSort.category === category && this.activeSort.direction === direction) {
      this.activeSort = null;
    } else {
      this.activeSort = { category, direction };
    }
    this.indicatorChanges.emit({categoryUuid: this.currentReport.details[this.currentPage].category.uuid, order: this.activeSort ? this.activeSort?.direction : null});
  }

  hasActiveSort(category: string): boolean {
    return (this.activeSort?.category === category);
  }

  isChecked(category: string, direction: SortDirection): boolean {
    return (this.activeSort?.category === category && this.activeSort?.direction === direction);
  }

}
